<template>
  <div class="bill-detail-breadcrumb">
    <mtd-breadcrumb style="display: inline-block;">
      <mtd-breadcrumb-item tag="router-link" :to="listUrl">
        账单列表
      </mtd-breadcrumb-item>
      <mtd-breadcrumb-item>对账单详情</mtd-breadcrumb-item>
    </mtd-breadcrumb>
  </div>
</template>

<script>
const listUrl = '/invoice-management/billConfirm'

export default {
  name: 'BillDetailBreadcrumb',
  data() {
    return {
      listUrl,
    }
  },
}
</script>

<style scoped></style>
